'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.googleSignup = exports.verified = exports.pathStart = undefined;

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _signupProducts = require('../constants/signupProducts');

var _signupProducts2 = _interopRequireDefault(_signupProducts);

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _appNames = require('../constants/appNames');

var _appNames2 = _interopRequireDefault(_appNames);

var _isApp = require('./isApp');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var product = function product(productValue) {
  return _AppConfigContainer2.default.get('signupProduct') === productValue;
};
var path = function path(pathValue) {
  return _AppConfigContainer2.default.get('baseHistoryPath') === pathValue;
};
var pathStart = exports.pathStart = function pathStart(pathValue) {
  return _AppConfigContainer2.default.get('baseHistoryPath') && _AppConfigContainer2.default.get('baseHistoryPath').startsWith(pathValue);
};
var intent = function intent(intentParam) {
  return _QueryParamsContainer2.default.get().get('intent') === intentParam;
};
var bundledOffer = function bundledOffer(bundledOfferParam) {
  return _QueryParamsContainer2.default.get().get('bundledOffer') === bundledOfferParam;
};
var merchandise = function merchandise(merchandiseParam) {
  return _QueryParamsContainer2.default.get().get('merchandise') === merchandiseParam;
};

var verified = exports.verified = function verified() {
  return _AppConfigContainer2.default.get('isVerified');
};
var googleSignup = exports.googleSignup = function googleSignup() {
  return _AppConfigContainer2.default.get('googleSignup');
};

exports.default = {
  wordpress: function wordpress() {
    return product(_signupProducts2.default.MARKETING_FREE) && path('wordpress');
  },
  academy: function academy() {
    return product(_signupProducts2.default.ACADEMY);
  },
  contentHubDeveloper: function contentHubDeveloper() {
    return product(_signupProducts2.default.STANDALONE_CMS_DEVELOPER);
  },
  contentHubPartner: function contentHubPartner() {
    return product(_signupProducts2.default.STANDALONE_CMS_PARTNER);
  },
  developers: function developers() {
    return product(_signupProducts2.default.DEVELOPERS);
  },
  directoryUser: function directoryUser() {
    return product(_signupProducts2.default.DIRECTORY_USER);
  },
  embeddedAcademy: function embeddedAcademy() {
    return product(_signupProducts2.default.ACADEMY) && path('embedded');
  },
  embeddedAllInOne: function embeddedAllInOne() {
    return pathStart('embedded-');
  },
  integrations: function integrations() {
    return product(_signupProducts2.default.CRM) && path('integrations');
  },
  classroomTraining: function classroomTraining() {
    return product(_signupProducts2.default.CRM) && path('classroom-training');
  },
  fbCrm: function fbCrm() {
    return product(_signupProducts2.default.CRM) && intent('fbCrm');
  },
  hubspotForStartups: function hubspotForStartups() {
    return product(_signupProducts2.default.HUBSPOT_FOR_STARTUPS);
  },
  marketing: function marketing() {
    return product(_signupProducts2.default.MARKETING_FREE);
  },
  marketingStarter: function marketingStarter() {
    return bundledOffer('MARKETING_HUB_STARTER');
  },
  partnerClient: function partnerClient() {
    return product(_signupProducts2.default.PARTNER_CLIENT_SIGNUP);
  },
  purchase: function purchase() {
    return intent('purchase') || path('purchase');
  },
  salesPartner: function salesPartner() {
    return product(_signupProducts2.default.SALES_PARTNER);
  },
  service: function service() {
    return product(_signupProducts2.default.SERVICE);
  },
  serviceStarter: function serviceStarter() {
    return merchandise('PRODUCT_SERVICE_STARTER');
  },
  legacyTrial: function legacyTrial() {
    return product(_signupProducts2.default.MARKETING_TRIAL);
  },
  trial: function trial() {
    return product(_signupProducts2.default.TRIAL);
  },
  growthHub: function growthHub() {
    return (0, _isApp.isApp)(_appNames2.default.growthHubSignup);
  },
  checkout: function checkout() {
    return (0, _isApp.isApp)(_appNames2.default.checkoutSignup);
  },
  crm: function crm() {
    return (0, _isApp.isApp)(_appNames2.default.crmSignup);
  },
  sales: function sales() {
    return (0, _isApp.isApp)(_appNames2.default.salesSignup);
  }
};